var map = {
	"./Bandeau_fracaq.jpg": "../../navigart-conf/img/branding/Bandeau_fracaq.jpg",
	"./NEW_Bandeau_fracaq_navigart.jpg": "../../navigart-conf/img/branding/NEW_Bandeau_fracaq_navigart.jpg",
	"./branding.png": "../../navigart-conf/img/branding/branding.png",
	"./frac_meca_logo2.png": "../../navigart-conf/img/branding/frac_meca_logo2.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./img/branding sync recursive ^\\.\\/.*$";